import {
    FETCH_INGESTION_FAILURES_REQUEST,
    FETCH_INGESTION_FAILURES_SUCCESS,
    FETCH_INGESTION_FAILURES_FAILURE,
    FETCH_INGESTION_FAILURE_DETAIL_REQUEST,
    FETCH_INGESTION_FAILURE_DETAIL_SUCCESS,
    FETCH_INGESTION_FAILURE_DETAIL_FAILURE,
    CLEAR_INGESTION_FAILURES
} from "api/menu/hr/ingestion-failures/actions";

const initialState = {
    ingestionFailures: [],
    selectedFailure: null,
    loading: false,
    detailLoading: false
};

export default function ingestionFailuresReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_INGESTION_FAILURES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_INGESTION_FAILURES_SUCCESS:
            return {
                ...state,
                ingestionFailures: action.payload,
                loading: false
            };
        case FETCH_INGESTION_FAILURES_FAILURE:
            return {
                ...state,
                loading: false
            };
        case FETCH_INGESTION_FAILURE_DETAIL_REQUEST:
            return {
                ...state,
                detailLoading: true
            };
        case FETCH_INGESTION_FAILURE_DETAIL_SUCCESS:
            return {
                ...state,
                selectedFailure: action.payload,
                detailLoading: false
            };
        case FETCH_INGESTION_FAILURE_DETAIL_FAILURE:
            return {
                ...state,
                detailLoading: false
            };
        case CLEAR_INGESTION_FAILURES:
            return initialState;
        default:
            return state;
    }
}

